<script lang="ts">
	import { fade } from 'svelte/transition'
	import { onMount, onDestroy } from 'svelte'
	import { appState } from '$lib/app-state.svelte'

	const millisecondsUntilClosed = 4000
	let isVisible = $state(false)
	let interval: NodeJS.Timeout | undefined = $state()
	let title = $state('')
	let message = $state('')
	let tone: Tone = $state('success')

	onMount(() => {
		appState.showToast = show
	})

	onDestroy(() => {
		if (interval) clearTimeout(interval)
	})

	function show(toast: Toast): void {
		tone = toast.tone
		title = toast.title
		message = toast.message
		isVisible = true

		interval = setTimeout(() => {
			isVisible = false
		}, millisecondsUntilClosed)
	}

	const onclick = () => (isVisible = false)
</script>

{#if isVisible}
	<!-- Toast container: fixed in the top-right corner -->
	<div class="tw:fixed tw:top-0 tw:end-0 tw:p-4 tw:text-white">
		<!-- Toast box: white background, drop shadow, rounded border -->
		<div
			id="toast"
			transition:fade={{ duration: 500 }}
			role="alert"
			aria-live="assertive"
			aria-atomic="true"
			class="tw:bg-plum tw:shadow-lg tw:drop-shadow-lg tw:rounded-md tw:border tw:border-plum tw:w-80 tw:max-w-full">
			<!-- Toast header: flex layout for the icon, title, and close button -->
			<div class="tw:flex tw:items-center tw:justify-between tw:px-4 tw:py-2">
				<span class="tw:text-bold tw:ml-1 tw:mr-auto" class:tw:text-red-500={tone == 'danger'}
					>{title}</span>
				<button
					{onclick}
					type="button"
					class="tw:text-white tw:hover:text-lilac tw:focus:outline-none">
					×
				</button>
			</div>
			<!-- Toast body: displays the message -->
			<div class="tw:px-4 tw:py-2">
				{message}
			</div>
		</div>
	</div>
{/if}
